const newrelic =
    typeof window !== "undefined" &&
    typeof window.NREUM === "object" &&
    window.NREUM;

export const logError = (
    err: Error,
    errorAttributes: Record<string, unknown>
) => {
    if (newrelic) newrelic.noticeError(err, errorAttributes);
};

export const addPageAction = (
    name: string,
    attributes?: Record<string, unknown>
) => {
    if (newrelic) newrelic.addPageAction(name, attributes);
};
